// Single source of truth for ProjectDetail's Live + Analytics query keys (#43).
// Keys follow the dashboard-* convention (CLAUDE.md). Defining queries and their
// scan-delete invalidations from the same roots prevents the drift that left
// Live/Analytics caches stale after deleteScanMutation.

export const liveKeys = {
  check: (projectId: string) => ['dashboard-live-check', projectId] as const,
  analytics: (projectId: string, timeRange: string, environment: string) =>
    ['dashboard-live-analytics', projectId, timeRange, environment] as const,
  analyticsPrev: (projectId: string, timeRange: string, environment: string) =>
    ['dashboard-live-analytics-prev', projectId, timeRange, environment] as const,
  costByProvider: (projectId: string, environment: string) =>
    ['dashboard-live-cost-by-provider', projectId, environment] as const,
  endpoints: (projectId: string) => ['dashboard-live-endpoints', projectId] as const,
  telemetry: (projectId: string, environment: string) =>
    ['dashboard-live-telemetry', projectId, environment] as const,
};

export const analyticsKeys = {
  tab: (projectId: string, period: string, environment: string) =>
    ['dashboard-analytics-tab', projectId, period, environment] as const,
  tabPrev: (projectId: string, period: string, environment: string) =>
    ['dashboard-analytics-tab-prev', projectId, period, environment] as const,
  telemetry: (projectId: string, environment: string) =>
    ['dashboard-analytics-telemetry', projectId, environment] as const,
  endpoints: (projectId: string) => ['dashboard-analytics-endpoints', projectId] as const,
  suggestions: (projectId: string) => ['dashboard-analytics-suggestions', projectId] as const,
};

// Prefix roots invalidated on scan delete. TanStack Query matches by prefix, so
// ['dashboard-live-analytics'] invalidates ['dashboard-live-analytics', id, ...].
export const scanDeleteInvalidationPrefixes: string[] = [
  'dashboard-live-check',
  'dashboard-live-analytics',
  'dashboard-live-analytics-prev',
  'dashboard-live-cost-by-provider',
  'dashboard-live-endpoints',
  'dashboard-live-telemetry',
  'dashboard-analytics-tab',
  'dashboard-analytics-tab-prev',
  'dashboard-analytics-telemetry',
  'dashboard-analytics-endpoints',
  'dashboard-analytics-suggestions',
];
